import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import './BottomNav.css';

const BottomNav = () => {
  const items = useMemo(
    () => [
      { key: 'home', to: '/', icon: 'bi-house-door', label: 'Projects' },
      { key: 'workplan', to: '/my-workplan', icon: 'bi-calendar-check', label: 'Workplan' },
      { key: 'charts', to: '/charts', icon: 'bi-bar-chart-line', label: 'Charts' },
      { key: 'config', to: '/configuration', icon: 'bi-gear', label: 'Config' }
    ],
    []
  );

  return (
    <nav className="bottom-nav" aria-label="Mobile navigation">
      <div className="bottom-nav__items">
        {items.map((item) => (
          <NavLink
            key={item.key}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              `bottom-nav__item ${isActive ? 'bottom-nav__item--active' : ''}`
            }
            aria-label={item.label}
          >
            <i className={`bi ${item.icon}`} aria-hidden="true" />
            <span className="bottom-nav__label">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
